<template>
  <div>
    <div class="hidden-xs-only hidden-sm-and-down bg-nosotros-2">
      <div data-aos="fade-right">
        <el-row :gutter="20"
          ><el-col :md="24"
            ><h2 class="title_desarrollo">{{ $t('desarrollo.titulo') }}</h2></el-col
          ></el-row
        >
      </div>
      <div data-aos="fade-right">
        <el-row :gutter="20"
          ><el-col :md="24" style="margin-top: 0px"
            ><p class="msj_cultura">{{ $t('desarrollo.texto') }}</p></el-col
          ></el-row
        >
      </div>
      <br />
      <div class="padre padre-heig" data-aos="fade-right">
        <div class="botones">
          <el-row v-if="lenguaje == 'es'">
            <el-col :md="16" :xs="24">
              <el-row :gutter="20" class="margin-botones">
                <el-col :md="12" :sm="12" :xs="24">
                  <button class="logo-btn" @click="changeInfo(1)">
                    <img :src="button1" class="logo-1" alt="cambiar texto" />
                  </button>
                </el-col>

                <el-col :md="12" :sm="12" :xs="24">
                  <button class="logo-btn" @click="changeInfo(2)">
                    <img :src="button2" class="logo-3" alt="cambiar texto" />
                  </button>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :md="12" :sm="12" :xs="24">
                  <button class="logo-btn" @click="changeInfo(3)">
                    <img :src="button3" class="logo-2" alt="cambiar texto" />
                  </button>
                </el-col>

                <el-col :md="12" :sm="12" :xs="24">
                  <button class="logo-btn" @click="changeInfo(4)">
                    <img :src="button4" class="logo-4" alt="cambiar texto" />
                  </button>
                </el-col>
                <!-- </div> -->
                <!-- <div class="button-group">
                <el-col :md="12" :sm="12" :xs="24">
                  <img :src="require('@/assets/iconos/prueba3.png')" class="button-img" alt="" />

                  <img style="margin-top: 50px" :src="require('@/assets/iconos/prueba4.png')" class="button-img" alt="" /> -->

                <!-- <el-button
                    class="button-left"
                    v-for="(btn, index) in buttons_2"
                    :key="index"
                    :class="{ 'active-button': selectedButton2 === index }"
                    @click="changeInfo(btn.estado, index)">
                    <img :src="btn.img" class="button-img" alt="" />
                    <h1 class="button-text">{{ $t(btn.titulo) }}</h1>
                  </el-button> -->
                <!-- </el-col>
              </div> -->
              </el-row>
            </el-col>
            <el-col :md="8" :xs="24">
              <img class="imagen-botones" :src="imagen" alt="cambiar texto" />
            </el-col>
          </el-row>
          <el-row v-if="lenguaje == 'en'">
            <el-col :md="16" :xs="24">
              <el-row :gutter="20" class="margin-botones">
                <el-col :md="12" :sm="12" :xs="24">
                  <button class="logo-btn" @click="changeInfo(1)">
                    <img :src="button1" class="logo-en-1" alt="cambiar texto" />
                  </button>
                </el-col>

                <el-col :md="12" :sm="12" :xs="24">
                  <button class="logo-btn" @click="changeInfo(2)">
                    <img :src="button2" class="logo-en-3" alt="cambiar texto" />
                  </button>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :md="12" :sm="12" :xs="24">
                  <button class="logo-btn" @click="changeInfo(3)">
                    <img :src="button3" class="logo-en-2" alt="cambiar texto" />
                  </button>
                </el-col>

                <el-col :md="12" :sm="12" :xs="24">
                  <button class="logo-btn" @click="changeInfo(4)">
                    <img :src="button4" class="logo-en-4" alt="cambiar texto" />
                  </button>
                </el-col>
              </el-row>
            </el-col>
            <el-col :md="8" :xs="24">
              <img class="imagen-botones" :src="imagen" alt="cambiar texto" />
            </el-col>
          </el-row>
        </div>
      </div>

      <div data-aos="fade-right"></div>
    </div>
    <div class="hidden-md-and-up bg-nosotros-2">
      <div data-aos="fade-right">
        <el-row :gutter="20"
          ><el-col :md="24"
            ><h2 class="title_desarrollo">{{ $t('desarrollo.titulo') }}</h2></el-col
          ></el-row
        >
      </div>
      <div data-aos="fade-right">
        <el-row :gutter="20"
          ><el-col :md="24" style="margin-top: 0px"
            ><p class="msj_cultura" style="text-align: left">{{ $t('desarrollo.texto') }}</p></el-col
          ></el-row
        >
      </div>

      <!-- <br /> -->
      <div data-aos="fade-right">
        <el-row :gutter="10">
          <el-col :xs="24">
            <el-collapse v-model="activeName" accordion>
              <el-collapse-item :title="$t('opciones.titulo_1')" name="1">
                <div style="font-size: 16px; color: #4b4b4a; font-family: 'roboto-regular'">
                  <p style="padding-left: 15px" v-html="$t('opciones.mensaje_1')"></p>
                </div>
              </el-collapse-item>
              <el-collapse-item :title="$t('opciones.titulo_2')" name="2">
                <div style="font-size: 16px; color: #4b4b4a; font-family: 'roboto-regular'">
                  <p style="padding-left: 15px" v-html="$t('opciones.mensaje_2')"></p>
                </div>
              </el-collapse-item>
              <el-collapse-item :title="$t('opciones.titulo_3')" name="3">
                <div style="font-size: 16px; color: #4b4b4a; font-family: 'roboto-regular'">
                  <p style="padding-left: 15px" v-html="$t('opciones.mensaje_3')"></p>
                </div>
              </el-collapse-item>
              <el-collapse-item :title="$t('opciones.titulo_4')" name="4">
                <div style="font-size: 16px; color: #4b4b4a; font-family: 'roboto-regular'">
                  <p style="padding-left: 15px" v-html="$t('opciones.mensaje_4')"></p>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- <div class="hidden-lg-and-up bg-nosotros-2">
      <div data-aos="fade-right">
        <el-row :gutter="20"
          ><el-col :md="24"
            ><h2 class="title_desarrollo">{{ $t('desarrollo.titulo') }}</h2></el-col
          ></el-row
        >
      </div>
      <div data-aos="fade-right">
        <el-row :gutter="20"
          ><el-col :md="24" style="margin-top: -30px"
            ><p class="texto_desarrollo">{{ $t('desarrollo.texto') }}</p></el-col
          ></el-row
        >
      </div>
      <div data-aos="fade-right">
        <el-row :gutter="10">
          <el-col :md="14" :xs="24">
            <el-row :gutter="10">
              <div class="button-group">
                <el-col :md="12" :sm="12" :xs="24">
                  <el-button class="button-left" v-for="(btn, index) in buttons" :key="index" :class="{ 'active-button': selectedButton === index }" @click="changeInfo(btn.estado, index)">
                    <img :src="btn.img" class="button-img" alt="" />
                    <h1 class="button-text">{{ $t(btn.titulo) }}</h1>
                  </el-button></el-col
                >
              </div>
              <div class="button-group">
                <el-col :md="12" :sm="12" :xs="24">
                  <el-button
                    class="button-left"
                    v-for="(btn, index) in buttons_2"
                    :key="index"
                    :class="{ 'active-button': selectedButton2 === index }"
                    @click="changeInfo(btn.estado, index)">
                    <img :src="btn.img" class="button-img" alt="" />
                    <h1 class="button-text">{{ $t(btn.titulo) }}</h1>
                  </el-button></el-col
                >
              </div></el-row
            >
          </el-col>
          <el-col :md="10" :xs="24" style="margin-top: 2%">
            <el-card class="card-css-1"
              ><h3 class="titulo-imagen">{{ $t(titulo) }}</h3>
              <p class="text-imagen-card" v-html="$t(mensaje)"></p></el-card
          ></el-col>
        </el-row>
      </div>
    </div> -->
  </div>
</template>
<script>
// import accounting from 'accounting'
// import ICountUp from 'vue-countup-v2'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { EventBus } from '@/event-bus.js'

export default {
  // components: { ICountUp },

  data() {
    return {
      lenguaje: 'es',
      titulo: 'opciones.titulo_1',
      mensaje: 'opciones.mensaje_1',
      clicked: false,
      // button1: require('@/assets/iconos/BLANCO_Aprendizaje.png'),
      // button2: require('@/assets/iconos/BLANCO_Capacitacion.png'),
      // button3: require('@/assets/iconos/BLANCO_Desarrollo.png'),
      // button4: require('@/assets/iconos/BLANCO_Acompañamiento.png'),
      button1: null,
      button2: null,
      button3: null,
      button4: null,
      // buttons_2: [
      //   { estado: 3, titulo: 'opciones.titulo_3', img: require('@/assets/iconos/08_Desarrollo continuo.png') },
      //   { estado: 4, titulo: 'opciones.titulo_3', img: require('@/assets/iconos/09_Desarrollo continuo.png') },
      // ],
      selectedButton: 0, // guarda el índice del botón activo
      selectedButton2: null, // guarda el índice del botón activo
      imagen: require('@/assets/fotos/RECUADRO_Aprendizaje.png'),
      imagen1: require('@/assets/fotos/RECUADRO_Aprendizaje_XS.png'),
      activeName: '1',
    }
  },

  mounted() {
    AOS.init({
      duration: 1000,
      offset: 100,
      once: false, // false = animaciones se repiten al volver a scrollear
    })

    if (this.$i18n.locale === 'en') {
      this.lenguaje = 'en'
      this.button1 = require('@/assets/iconos/BLANCO_Learning.png')
      this.button2 = require('@/assets/iconos/BLANCO_Training.png')
      this.button3 = require('@/assets/iconos/BLANCO_Development.png')
      this.button4 = require('@/assets/iconos/BLANCO_Support.png')
      this.imagen = require('@/assets/fotos/RECUADRO_Learning.png')
    } else {
      this.lenguaje = 'es'
      this.button1 = require('@/assets/iconos/BLANCO_Aprendizaje.png')
      this.button2 = require('@/assets/iconos/BLANCO_Capacitacion.png')
      this.button3 = require('@/assets/iconos/BLANCO_Desarrollo.png')
      this.button4 = require('@/assets/iconos/BLANCO_Acompaniamiento.png')
    }

    EventBus.$on('change-lenguaje', (lenguaje) => {
      this.lenguaje = lenguaje
      if (lenguaje == 'es') {
        this.button1 = require('@/assets/iconos/BLANCO_Aprendizaje.png')
        this.button2 = require('@/assets/iconos/BLANCO_Capacitacion.png')
        this.button3 = require('@/assets/iconos/BLANCO_Desarrollo.png')
        this.button4 = require('@/assets/iconos/BLANCO_Acompaniamiento.png')
      } else {
        this.button1 = require('@/assets/iconos/BLANCO_Learning.png')
        this.button2 = require('@/assets/iconos/BLANCO_Training.png')
        this.button3 = require('@/assets/iconos/BLANCO_Development.png')
        this.button4 = require('@/assets/iconos/BLANCO_Support.png')
        this.imagen = require('@/assets/fotos/RECUADRO_Learning.png')
      }
    })
  },

  beforeDestroy() {
    EventBus.$off('change-lenguaje', false)
  },
  methods: {
    changeInfo(estado) {
      switch (estado) {
        case 1:
          this.imagen = this.lenguaje == 'es' ? require('@/assets/fotos/RECUADRO_Aprendizaje.png') : require('@/assets/fotos/RECUADRO_Learning.png')
          break
        case 2:
          this.imagen = this.lenguaje == 'es' ? require('@/assets/fotos/RECUADRO_Capacitacion.png') : require('@/assets/fotos/RECUADRO_Training.png')
          break
        case 3:
          this.imagen = this.lenguaje == 'es' ? require('@/assets/fotos/RECUADRO_Desarrollo.png') : require('@/assets/fotos/RECUADRO_Development.png')
          break
        case 4:
          this.imagen = this.lenguaje == 'es' ? require('@/assets/fotos/RECUADRO_Acompaniamiento.png') : require('@/assets/fotos/RECUADRO_Support.png')
          break
      }
    },
  },
}
</script>
<style scoped>
.el-collapse-item__header {
  color: #303133;
  font-size: 18px !important;
  font-family: 'roboto-black';
}
.el-button:hover,
.el-button:active {
  color: #fff !important;
  border-color: #e9eef3;
  background-color: #d35400;
}
.button-group >>> .el-button {
  margin: 5px;
  border-color: #ccc;
}

/* estilo cuando el botón está seleccionado */
.button-group >>> .active-button {
  color: #fff !important;
  background-color: #d35400 !important;
  border-color: #e9eef3 !important;
}
/* .button-left >>> .el-button:hover,
.button-left >>> .el-button:active {
  color: #fff !important;
  border-color: #e9eef3;
  background-color: #d35400;
} */
</style>
<style>
.el-collapse-item__header {
  /* color: #4b4b4a; */
  color: #d35400;
  font-size: 18px !important;
  font-family: 'roboto-black';
  padding-left: 15px;
}
.el-collapse-item__header.is-active {
  background-color: #d35400;
  color: white;
  padding-left: 15px;
}
.el-collapse-item__arrow.is-active {
  color: white;
}
.el-collapse-item__arrow {
  color: #d35400;
  font-weight: 900;
  font-family: 'roboto-regular';
}
.imagen-botones {
  background-size: cover;
  /* border: 1px solid; */
  /* box-shadow: rgb(0 0 0 / 38%) 0px 2px 12px 0px; */
  border-radius: 4px;
  /* border: 1px solid #ebeef5; */
  /* background-color: #fff; */
  overflow: hidden;
  color: #303133;
  transition: 0.3s;
  width: 94%;
  margin-left: 20px;
}
.padre {
  display: grid;
  grid-template-columns: auto auto;
  align-items: stretch; /* hace que ambos hijos tengan la misma altura */
}
.padre-heig {
  /* height: 35.6vh; */
}

.cuadro2 {
  /* border: 1px solid; */
  padding: 30px;
  box-sizing: border-box;
  border: 1px solid #ebeef5;
  background-color: #fff;
  box-shadow: rgb(0 0 0 / 38%) 0px 2px 12px 0px;
}
.margin-botones {
  /* margin-top: -14px; */
  padding-bottom: 17.5px;
}
/* ------------------ */
.logo-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  width: 50%;
}
.logo-1,
.logo-2,
.logo-3,
.logo-4 {
  width: 200%;
}

.logo-en-1,
.logo-en-2,
.logo-en-3,
.logo-en-4 {
  width: 200%;
}
.logo-en-1:hover,
.logo-btn:focus .logo.logo-en-1 {
  content: url('~@/assets/iconos/NARANJA_Learning.png');
  width: 200%;
}
.logo-en-3:hover,
.logo-btn:focus .logo-en-3 {
  content: url('~@/assets/iconos/NARANJA_Training.png');
  width: 200%;
}
.logo-en-2:hover,
.logo-btn:focus .logo-en-2 {
  content: url('~@/assets/iconos/NARANJA_Development.png');
  width: 200%;
}
.logo-en-4:hover,
.logo-btn:focus .logo-en-4 {
  content: url('~@/assets/iconos/NARANJA_Support.png');
  width: 200%;
}

.logo-1:hover,
.logo-btn:focus .logo-1 {
  content: url('~@/assets/iconos/NARANJA_Aprendizaje.png');
  width: 200%;
}
.logo-3:hover,
.logo-btn:focus .logo-3 {
  content: url('~@/assets/iconos/NARANJA_Capacitación.png');
  width: 200%;
}
.logo-2:hover,
.logo-btn:focus .logo-2 {
  content: url('~@/assets/iconos/NARANJA_Desarrollo.png');
  width: 200%;
}
.logo-4:hover,
.logo-btn:focus .logo-4 {
  content: url('~@/assets/iconos/NARANJA_Acompañammiento.png');
  width: 200%;
}
/* ------------------ */
.titulo-imagen {
  color: #d35400;
}
.text-imagen-card {
  font-family: 'roboto-regular';
  font-size: 0.9rem;
  text-align: justify;
  hyphens: auto;
}
.card-css-1 {
  height: 100%;
  margin: 0px;
  padding: 20px;
}
.title_desarrollo {
  color: #d35400;
  font-family: 'roboto-cursiva-black';
  margin: 0% 0px 10% 0px;
}
.texto_desarrollo {
  font-family: 'roboto-regular';
  font-size: 0.9rem;
  text-align: justify;
  hyphens: auto;
  margin-top: 0px;
}
.button-left {
  border-bottom-left-radius: 70px;
  border: none;
  padding: 0px;
  color: #d35400;
  height: 120px;
  border-color: #cccccc3b !important;
}
.boton {
  width: 200px;
  height: 60px;
  background: #d35603;
  color: white;
  font-size: 18px;
  font-weight: bold;
  border: none;
  cursor: pointer;

  clip-path: url(#formaMascara);
}
.button-img {
  width: 100%;
  float: inline-start;
  margin-left: -5px;
  margin-top: -10px;
}

.button-text {
  justify-content: center;
  /* align-items: center; */
  /* height: 40px; */
  display: flex;
  justify-content: center;
  align-items: center;
  /* width: 150px; */
  height: 50%;

  font-size: 1.2rem;
}

/* PARTE ANTERIOR */
.card-centrada {
  display: flex;
  justify-content: center; /* Centra horizontalmente todo el bloque */
  align-items: center; /* Centra verticalmente dentro del card */
  height: 100%; /* Ajustar según el alto de la tarjeta */
  text-align: center;
  border: 0px !important;
}

.contenido-centrado {
  display: flex;
  align-items: center; /* Alinea verticalmente la imagen con el texto */
  justify-content: center; /* Centra ambos dentro del card */
  gap: 1.5rem; /* Espacio entre imagen y texto */
}

.contenido-centrado img {
  width: 80px; /* Ajustá el tamaño según tu diseño */
  height: auto;
}

.texto h2 {
  color: #d35400; /* Mismo color que en tu ejemplo */
  font-size: 2rem;
  margin: 0;
  font-weight: 700;
  font-family: 'roboto-black';
}

.texto p {
  color: #d35400;
  font-size: 0.9rem;
  margin: 0;
  text-align: justify;
  font-family: 'roboto-regular';
}
.img-style {
  width: 25%;
  /* float: inline-end; */
  text-align: center;
}
.subtitulo_numeros {
  font-size: 20px;
  margin-top: -40px;
  font-family: 'roboto-regular';
}
@media (min-width: 2561px) {
  .title_desarrollo {
    font-size: 62px;
    margin: 0% 0px 1% 0px;
  }
  .texto_desarrollo {
    font-size: 25px;
  }
  .button-text {
    font-size: 37px;
  }
  .button-left {
    border-bottom-left-radius: 100px;
    padding: 0px;
    color: #d35400;
    height: 215px;
    border-bottom-width: initial;
  }
  .button-img {
    width: 35%;
    float: inline-start;
    margin-left: -12px;
    margin-top: -12px;
  }
  .card-css-1 {
    height: 450px !important;
    margin: 0px;
    margin-left: 20px;
    /* margin-top: 40px; */
  }
}
@media screen and (min-width: 1920px) and (max-width: 2560px) {
  .title_desarrollo {
    font-size: 62px;
    margin: 0% 0px 1% 0px;
  }
  .texto_desarrollo {
    font-size: 23px;
  }
  .button-text {
    font-size: 35px;
  }
  .button-left {
    border-bottom-left-radius: 85px;
    padding: 0px;
    color: #d35400;
    height: 145px;
    border-bottom-width: initial;
  }
  .button-img {
    width: 100%;
    float: inline-start;
    /* margin-left: -12px; */
    margin-top: 5%;
  }
  .titulo-imagen {
    margin: 0px;
    font-size: 39px;
  }
  .text-imagen-card {
    font-size: 23px;
  }
  .card-css-1 {
    height: 290px;
    margin: 0px;
    margin-left: 20px;
    /* margin-top: 12px; */
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .title_desarrollo {
    font-size: 56px;
    margin: 0% 0px 1% 0px;
  }
  .texto_desarrollo {
    font-size: 21px;
  }
  .button-text {
    font-size: 27px;
    height: 65%;
  }
  .button-left {
    border-bottom-left-radius: 75px;
    padding: 0px;
    color: #d35400;
    height: 145px;
    border-bottom-width: initial;
  }
  .button-img {
    width: 41%;
    float: inline-start;
    margin-left: -12px;
    margin-top: -12px;
  }
  .titulo-imagen {
    margin: 0px;
    font-size: 31px;
  }
  .text-imagen-card {
    font-size: 21px;
  }
  .card-css-1 {
    height: 290px;
    margin: 0px;
    margin-left: 20px;
    /* margin-top: 10px; */
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .imagen-botones {
    background-size: cover;
    /* border: 1px solid; */
    /* box-shadow: rgb(0 0 0 / 38%) 0px 2px 12px 0px; */
    border-radius: 4px;
    /* border: 1px solid #ebeef5; */
    /* background-color: #fff; */
    overflow: hidden;
    color: #303133;
    transition: 0.3s;
    width: 95%;
    margin-left: 20px;
  }
  .title_desarrollo {
    font-size: 50px;
    margin: 0% 0px 1% 0px;
  }
  .texto_desarrollo {
    font-size: 19px;
  }
  .button-text {
    font-size: 26px;
    height: 65%;
  }
  .button-left {
    border-bottom-left-radius: 60px;
    padding: 0px;
    color: #d35400;
    height: 110px;
    /* border-bottom-width: initial; */
  }
  .button-img {
    width: 35%;
    float: inline-start;
    margin: -5px;
  }
  .titulo-imagen {
    margin: 0px;
    font-size: 26px;
  }
  .text-imagen-card {
    font-size: 19px;
    text-align: left;
  }
  .card-css-1 {
    height: 240px;
    margin: 0px;
    margin-left: 20px;
    /* margin-top: 40px; */
  }
  .margin-botones {
    /* margin-top: -10px; */
  }
  .padre-heig {
    /* height: 30.5vh; */
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .imagen-botones {
    background-size: cover;
    /* border: 1px solid; */
    /* box-shadow: rgb(0 0 0 / 38%) 0px 2px 12px 0px; */
    border-radius: 4px;
    /* border: 1px solid #ebeef5; */
    /* background-color: #fff; */
    overflow: hidden;
    color: #303133;
    transition: 0.3s;
    width: 98%;
    margin-left: 20px;
  }
  .title_desarrollo {
    font-size: 40px;
    margin: 0% 0px 10% 0px;
  }
  .texto_desarrollo {
    font-size: 19px;
  }
  .button-text {
    font-size: 19px;
    height: 65%;
  }
  .button-left {
    border-bottom-left-radius: 50px;
    padding: 0px;
    color: #d35400;
    height: 105px;
  }
  .button-img {
    width: 35%;
    float: inline-start;
    margin: -8px;
    /* margin-left: -7px; */
    /* margin-top: -9px; */
  }
  .titulo-imagen {
    margin: 0px;
    font-size: 19px;
  }
  .text-imagen-card {
    font-size: 19px;
    text-align: left;
  }
  .card-css-1 {
    height: 200px;
    margin-top: 0px;
    margin-left: 20px;
    padding: 20px;
  }
}
@media screen and (min-width: 375px) and (max-width: 767px) {
  .title_desarrollo {
    font-size: 35px;
    /* margin: 20px 0px; */
  }
  .texto_desarrollo {
    font-size: 18px;
    text-align: justify;
  }
  .button-text {
    font-size: 22px;
    height: 65%;
  }
  .button-left {
    border-bottom-left-radius: 60px;
    padding: 0px;
    color: #d35400;
    height: 100px;
    border-bottom-width: initial;
  }
  .button-img {
    width: 35%;
    float: inline-start;
    margin-left: -4px;
    margin-top: -6px;
  }
  .titulo-imagen {
    margin: 0px;
    font-size: 22px;
  }
  .text-imagen-card {
    font-size: 18px;
    text-align: left;
  }
  .card-css-1 {
    height: 100%;
    margin: 0px;
    padding: 25px;
  }

  .logo-btn {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    width: 70%;
    -webkit-tap-highlight-color: transparent;
    background: none;
    border: none;
    outline: none;
    margin-top: -20px;
  }
  .logo-1,
  .logo-3,
  .logo-2,
  .logo-4 {
    width: 142%;
    margin-top: 50px;
  }
  .logo-1:hover,
  .logo-btn:focus .logo-1 {
    content: url('~@/assets/iconos/prueba1.png');
    width: 142%;
  }
  .logo-3:hover,
  .logo-btn:focus .logo-3 {
    content: url('~@/assets/iconos/prueba3.png');
    width: 142%;
  }
  .logo-2:hover,
  .logo-btn:focus .logo-2 {
    content: url('~@/assets/iconos/prueba2.png');
    width: 142%;
  }
  .logo-4:hover,
  .logo-btn:focus .logo-4 {
    content: url('~@/assets/iconos/prueba4.png');
    width: 142%;
  }
  .imagen-botones {
    transition: 0.3s;
    width: 100%;
    margin-left: 0px;
    margin-top: 10%;
    border: 1px solid #ce5a15;
  }
}
@media (max-width: 375px) {
  .title_desarrollo {
    font-size: 31px;
    /* margin: 20px 0px; */
  }
  .texto_desarrollo {
    font-size: 18px;
    text-align: justify;
  }
  .button-text {
    font-size: 18px;
    height: 65%;
  }
  .button-left {
    border-bottom-left-radius: 52px;
    padding: 0px;
    color: #d35400;
    height: 90px;
    border-bottom-width: initial;
  }

  .button-img {
    width: 35%;
    float: inline-start;
    margin-left: -4px;
    margin-top: -6px;
  }
  .titulo-imagen {
    margin: 0px;
    font-size: 22px;
  }
  .text-imagen-card {
    font-size: 19px;
    text-align: left;
  }
  .card-css-1 {
    height: 100%;
    margin: 0px;
    padding: 25px;
  }
  .logo-btn {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    width: 70%;
    -webkit-tap-highlight-color: transparent;
    background: none;
    border: none;
    outline: none;
    margin-top: -20px;
  }
  .logo-1,
  .logo-3,
  .logo-2,
  .logo-4 {
    width: 142%;
    margin-top: 50px;
  }
  .logo-1:hover,
  .logo-btn:focus .logo-1 {
    content: url('~@/assets/iconos/NARANJA_Aprendizaje.png');
    width: 142%;
  }
  .logo-3:hover,
  .logo-btn:focus .logo-3 {
    content: url('~@/assets/iconos/prueba3.png');
    width: 142%;
  }
  .logo-2:hover,
  .logo-btn:focus .logo-2 {
    content: url('~@/assets/iconos/prueba2.png');
    width: 142%;
  }
  .logo-4:hover,
  .logo-btn:focus .logo-4 {
    content: url('~@/assets/iconos/prueba4.png');
    width: 142%;
  }
  .imagen-botones {
    transition: 0.3s;
    width: 100%;
    margin-left: 0px;
    margin-top: 10%;
    border: 1px solid #ce5a15;
  }
}
@media (orientation: landscape) and (max-height: 450px) {
  .title_desarrollo {
    margin: 0% 0px 3% 0px;
  }
}
/* @media screen and (min-width: 599px) and (max-width: 767px) {
  .title_desarrollo {
    font-size: 31px;
    margin: 20px 0px;
  }
  .texto_desarrollo {
    font-size: 19px;
  }
  .button-text {
    font-size: 22px;
    height: 65%;
  }
  .button-left {
    border-bottom-left-radius: 50px;
    padding: 0px;
    color: #d35400;
    height: 107px;
  }
  .button-img {
    width: 24%;
    float: inline-start;
    margin: -5px;

  }
  .titulo-imagen {
    margin: 0px;
    font-size: 22px;
  }
  .text-imagen-card {
    font-size: 19px;
    text-align: left;
  }
  .card-css-1 {
    height: 100%;
    margin: 0px;
  }
} */
/* @media screen and (min-width: 376px) and (max-width: 598px) {
  .title_desarrollo {
    font-size: 31px;
    margin: 20px 0px;
  }
  .texto_desarrollo {
    font-size: 19px;
    text-align: justify;
  }
  .button-text {
    font-size: 22px;
    height: 65%;
  }
  .button-left {
    border-bottom-left-radius: 68px;
    padding: 0px;
    color: #d35400;
    height: 110px;
    border-bottom-width: initial;
  }
  .button-img {
    width: 30%;
    float: inline-start;
    margin-left: -6px;
    margin-top: -10px;
  }
  .titulo-imagen {
    margin: 0px;
    font-size: 22px;
  }
  .text-imagen-card {
    font-size: 19px;
    text-align: left;
  }
  .card-css-1 {
    height: 100%;
    margin: 0px;
  }
} */

/* @media (max-width: 375px) {
  .msj_cultura {
    font-size: 13px;
  }
  .card-sumate {
    display: grid;
    align-items: center;
    margin-top: 10%;
  }
  .title2 {
    font-size: 12px;
  }
} */
</style>
